import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { MenuService } from 'src/app/services/menu.service';
import { SettingsService } from 'src/app/services/settings.service';
import { StorageService } from 'src/app/services/storage-service.service';
import { MenuItem } from 'src/app/shared/interfaces/data.interfaces';
import { UserTypeEnum } from '../../../interfaces/data.interfaces';
@Component({
  selector: 'app-home-layout',
  standalone: false,
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.scss'
})
export class HomeLayoutComponent {
  mainMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleMenu: MenuItem[];
  @Input() moduleIconType: 'SVG' | 'MATERIAL';
  @Input() moduleIconTitle: string;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  loggedInUserType: UserTypeEnum;
    constructor(
    private breakpointObserver: BreakpointObserver,
    private settingsService: SettingsService,
    private menuService: MenuService,
    private storageService: StorageService,
  ) {
    this.loggedInUserType = this.storageService.get('category');
  }
    ngOnInit() {
    this.mainMenu = [ {
       
        name: 'home',
        description: '',
        logo: '/assets/images/svg/person.svg',
        route: '/online',
        userType: UserTypeEnum.GUEST,
        permissions: []
      },
    ]
  }
}
